import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { clusterPricingGuard } from "./guards/cluster-pricing.guard";
import { PageNotFoundComponent } from "./layout/page-not-found/page-not-found.component";
import { featureRoutes } from "../configuration/feature-routes";
import { MainLayoutComponent } from "./layout/main-layout/main-layout.component";

export const coreRoutes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'cluster-pricing-configuration',
        canActivate: [clusterPricingGuard],
        loadComponent: () =>
          import('./pages/cluster-pricing/pricing-configuration/pricing-configuration.component').then(
            (m) => m.PricingConfigurationComponent,
          ),
      },
      {
        path: 'page-not-found',
        component: PageNotFoundComponent,
      },
      ...featureRoutes,
    ],
  },
];

@NgModule( {
  imports: [RouterModule.forChild( coreRoutes )],
  exports: [RouterModule]
} )
export class CoreRoutingModule {
}
